import {Directive, Input, Output, EventEmitter} from '@angular/core';

@Directive({
  selector: '[ngInit]'
})
export class NgInitDirective {

  @Input() loaded: boolean;
  @Output('ngInit') initEvent: EventEmitter<any> = new EventEmitter();
  
  ngOnInit() {
    if (this.loaded) {
      setTimeout(() => this.initEvent.emit(), 10);
    }
  }
}